import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.414 10.472 8.943 10l.471-.471a.667.667 0 1 0-.943-.943L8 9.057l-.471-.471a.667.667 0 0 0-.943.943l.471.471-.471.472a.667.667 0 1 0 .943.942L8 10.943l.471.471a.667.667 0 0 0 .943-.942"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.293 5.78q.03.088.04.18v6.707a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2H8.7q.117.015.22.074a.2.2 0 0 1 .06 0 .7.7 0 0 1 .187.126l4 4a.7.7 0 0 1 .126.187zm-2.233-.447L9.333 3.607v1.06a.667.667 0 0 0 .667.666zm.745 7.805a.67.67 0 0 0 .195-.471v-6h-2a2 2 0 0 1-2-2v-2H4.667A.667.667 0 0 0 4 3.333v9.334a.667.667 0 0 0 .667.666h6.666c.177 0 .347-.07.472-.195",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })